import React from 'react'

import styles from './styles'

const AboutTerms = () => (
  <section>
    <h3 id="about-terms" data-level="1" className={styles.subHeading}>About These Terms</h3>

    <p>OfferZen offers a way for Employers and Candidates to connect.</p>
    <p>
      These Terms are entered into by OfferZen (defined below) and the person
      agreeing to these Terms by accessing and using the Services (defined
      below). These Terms govern your access to and use of OfferZen and our
      Service and are effective from the Effective Date and will endure for so
      long as you use the Services and/or unless terminated in accordance with
      the Agreement.
    </p>
    <p>
      A Proposal and these Terms will form one agreement between the Employer
      and OfferZen (“<b>Agreement</b>”). The Agreement collectively grants Employers
      access to the Service to make placements of Candidates on the terms set
      out in the Agreement.
    </p>
    <p>
      These Terms refer to additional terms including our{' '}
      <a href="/privacy" target="_blank" rel="noreferrer">Privacy Policy</a>,{' '}
      <a href="/cookie-declaration" target="_blank" rel="noreferrer">Cookie Declaration</a> and{' '}
      <a href="/code_of_conduct" target="_blank" rel="noreferrer">Code of Conduct</a>.{' '}
      These other terms also apply to your use of our Services so it’s important to read and understand them.
    </p>
  </section>
)

export default AboutTerms
